import Vue from 'vue';
import { api } from "../../services/Api.js"
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export function delete_calendar_item({ commit, state }, payload){
     
    // adding token
    payload.token=state.appSettings.token

    var store_key=payload.cal_id+"calendar";

    modalService.createModal(i18n.t('language.calendar_item_delete_sure')).then(
    ()=>{

      // get active school
      var school = state.user_schools.find(school => school.active === 1);

      api
      .post(school,"delete_cal_item.php",payload)
      .then( () =>{         
        
        state.calendar[store_key].dates.forEach(date=>{
          date.items.forEach(item=>{
            if(item.id==payload.id){
              // remove it from date.items
              if(date.items.length==1){
                // remove parent and item
                let index = state.calendar[store_key].dates.indexOf(date);
                // delete whole item
                commit('DELETE_CALENDAR_ITEM', {key:store_key ,index:index});
              }else{
                // remove item only
                let index = date.items.indexOf(item);
                date.items.splice(index, 1);  
              }
               
            }
          });
        })

         // set mutations for all other componetns that might need it
         //commit('SET_CALENDAR', state.calendar);
         Vue.$toaster.toast("language.calendar_item_delete_success");
        
      })
      .catch( error => {
        alert("store: delete_calender_item: "+error)
      })


    },
      () => {} // cancel modal
    )// modal

  }